import styled from 'styled-components'

import {
  backgroundTypes,
  boxModelTypes,
  cssTypes,
  displayTypes,
  positionTypes,
} from '../types'
import { background, boxModel, css, display, position } from '../util'

/**
 * @namespace Aside
 * @desc Primitive styled-component 💅
 * @return {Function} React component
 */
const Aside = styled.aside`
  ${background};
  ${boxModel};
  ${css};
  ${display};
  ${position};
`

/**
 * @name defaultProps
 * @memberof Aside
 * @desc Primitive's default properties
 */
Aside.defaultProps = {
  display: 'block',
  margin: [0],
  padding: [0],
  size: ['auto'],
}

/**
 * @name propTypes
 * @memberof Aside
 * @desc Primitive's prop type definitions
 */
Aside.propTypes = {
  ...backgroundTypes,
  ...boxModelTypes,
  ...cssTypes,
  ...displayTypes,
  ...positionTypes,
}

/** @component */
export default Aside
